var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.id == 23)?_c('Cordoba',{attrs:{"municipio_id":_vm.id}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }